import { graphql } from "../../generated";

export const uploadImageMutation = graphql(/* GraphQL */ `
    mutation UploadImage($filename: String!) {
        uploadImage(filename: $filename) {
            id
            objectKey
            src
            presignedUploadUrl
        }
    }
`);

export const duplicateImageMutation = graphql(/* GraphQL */ `
    mutation DuplicateImage($id: String!) {
        duplicateImage(id: $id) {
            id
            objectKey
            src
        }
    }
`);
